import { postRequest } from '@services/commService';
import { TIME_TRACKING_ENDPOINTS, TIME_TRACKING_SERVER } from '@services/servers';
import { TimeTracking, CreateTimeTrackingRecord, UpdateTimeTrackingRecord } from './types';

export const createTimeTracking = async (input: CreateTimeTrackingRecord): Promise<TimeTracking> => {
  try {
    const response = await postRequest(
      TIME_TRACKING_SERVER,
      TIME_TRACKING_ENDPOINTS.CREATE_TIME_TRACKING,
      input as any,
    );
    return response?.body?.data;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : 'Failed to save time tracking');
  }
};

export const updateTimeTracking = async (input: UpdateTimeTrackingRecord): Promise<TimeTracking> => {
  try {
    const response = await postRequest(
      TIME_TRACKING_SERVER,
      TIME_TRACKING_ENDPOINTS.UPDATE_TIME_TRACKING,
      input as any,
    );
    return response?.body?.data;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : 'Failed to update time tracking');
  }
};
